import { render, staticRenderFns } from "./StatsSite.vue?vue&type=template&id=6a680e7f&scoped=true"
import script from "./StatsSite.vue?vue&type=script&lang=js"
export * from "./StatsSite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a680e7f",
  null
  
)

export default component.exports